<div [ngClass]="compact ? 'compact' : 'enviar-comentario'">
  <form [formGroup]="comentarioForm" class="form-login" (ngSubmit)="enviarComentario()">
    <ng-container *ngIf="showTextarea">
      <mat-form-field (click)="expand()" appearance="outline" class="field-textarea" [ngClass]="{ shake: shake, 'dialog-class': true }">
        <mat-label *ngIf="!compact">{{ placeholder }}</mat-label>
        <textarea #textarea formControlName="comentario" [ngClass]="[expanded ? '' : 'collapsed']" matInput class="text-area-comentario"></textarea>
        <mat-error *ngIf="comentarioForm.get('comentario').errors?.required && comentarioForm.touched">Comentario vacío.</mat-error>
        <mat-error *ngIf="comentarioForm.get('comentario').errors?.pattern && comentarioForm.touched">No se permiten solo espacios.</mat-error>
        <mat-error *ngIf="comentarioForm.get('comentario').errors?.minlength && comentarioForm.touched">Comentario muy corto.</mat-error>
        <mat-error *ngIf="comentarioForm.get('comentario').errors?.serverError && comentarioForm.touched">{{ comentarioForm.get("comentario").errors?.serverError }}</mat-error>
        <ng-container *ngIf="!comentariosAnonimos">
          <mat-error *ngIf="comentarioForm.get('comentario').errors?.notLoggedIn && comentarioForm.touched">Debes iniciar sesión para escribir.</mat-error>
        </ng-container>

        <ng-container *ngIf="showBtnEnvio && expanded">
          <button mat-button align="end" type="submit" class="btn-enviar-comentario">
            <ng-container *ngIf="!compact">
              {{ textoBtnEnvio }}
            </ng-container>
            <ng-container *ngIf="compact"> Responder </ng-container>
            <span *ngIf="!login && !compact">*</span>
          </button>
        </ng-container>
      </mat-form-field>
    </ng-container>
  </form>
  <div *ngIf="!login && !compact" class="nota-informativa">* {{ notaInformativa }}</div>
</div>
